import {  Box, } from "@mui/material";
import { H4, H6 } from "../components/Typography";
import { FC } from "react";
interface CardProps {
  data?: any;
  status?:any
}

const TicketsCard: FC<CardProps> = ({ data,status }) => {
  let timestamp = data.last_message_time;
    let date = new Date(timestamp);

  return (
    <Box
      sx={{
        width: "98%",
        background: "#fff",
        borderRadius: 2,
        p: 2,
        flexDirection: "row",
        display: "flex",
        justifyContent: "space-between",
        mt: 2,
        boxShadow:1
      }}
    >
      <Box
        sx={{
          width: "12%",
          justifyContent: "space-around",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <H4
          sx={{
            fontFamily: "'Poppins', sans-serif",
            textAlign: "left",

            color: "#000",
          }}
          fontWeight={"600"}
        >
          Ticket ID: {data?.id ?? ""}
        </H4>
        <H6
          sx={{
            fontFamily: "'Poppins', sans-serif",
            textAlign: "left",

            color: "#5B5959",
          }}
          fontWeight={"500"}
        >
        {data?.subject ?? ""}
        </H6>
      </Box>
     
      <Box
        sx={{
          width: "12%",
          justifyContent: "space-between",
          pl: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
         <H6
          sx={{
            fontFamily: "'Poppins', sans-serif",
            textAlign: "left",

            color: data?.status?.name === 'Open' ? '#EFA000' : '#f00',
          }}
          fontWeight={"500"}
        >
          {status}
        </H6>
      </Box>
    </Box>
  );
};

export default TicketsCard;
